<sb-card halfHeight="false">
  <div card-header>
    <h1>{{ 'lang.dashboard.playoutsOverAllCampaigns' | translate }}</h1>
    <small>{{ 'lang.dashboard.pastCountDays' | translate: {count: 7} }}</small>
  </div>
  <sb-chart #chart chartType="lineChart" card-body [chartData]="lineChartGradient"></sb-chart>
</sb-card>
